import { propOr, prop, map } from 'ramda';
import { dateFormat, checkValuesNotEmpty } from '../../shared/utils';

class BusinessParameters {

  constructor(parameters) {
    this.parameters = parameters;
  }

  #formatDocumentTypes(documentTypes) {
    return map((document) => ({
      value: prop('code', document),
      textContent: prop('nameParameter', document),
      shortContent: prop('codeParameter', document),
    }), documentTypes);
  }

  #formatRelationshipTypes(relationshipTypes) {
    return map((relationship) => ({
      value: prop('idParameter', relationship),
      label: prop('codeParameter', relationship),
    }), relationshipTypes);
  }

  #formatHealthStatusTypes(healthStatusTypes) {
    return map((healthStatus) => ({
      value: prop('idParameter', healthStatus),
      label: prop('codeParameter', healthStatus),
    }), healthStatusTypes);
  }

  #formatGenderStatusTypes(sexStatusTypes) {
    return map((sexStatus) => ({
      value: prop('idParameter', sexStatus),
      label: prop('codeParameter', sexStatus),
    }), sexStatusTypes);
  }

  get documentTypes() {
    const documentTypes = propOr([], 'documentTypes', this.parameters);
    return this.#formatDocumentTypes(documentTypes);
  }

  get basketBasicAmount() {
    return prop('basketBasicAmount', this.parameters);
  }

  get relationshipTypes() {
    const relationshipTypes = propOr([], 'relationshipTypes', this.parameters);
    return  this.#formatRelationshipTypes(relationshipTypes);
  }

  get healthStatusTypes() {
    const healthStatusTypes = propOr([], 'healthStatusTypes', this.parameters);
    return  this.#formatHealthStatusTypes(healthStatusTypes);
  }

  get genderStatusTypes() {
    const genderStatusTypes = propOr([], 'sexStatusTypes', this.parameters);
    return  this.#formatGenderStatusTypes(genderStatusTypes);
  }

  get processStartDate() {
    return propOr('', 'dateStart', this.parameters);
  }

  get minimumBalance() {
    return propOr('', 'amount', this.parameters);
  }

  formatBeneficiariesToFetch(beneficiaries) {
    const filteredNoEmpty = beneficiaries.filter(checkValuesNotEmpty);
    const formattedDate = filteredNoEmpty.map(beneficiary => ({ ...beneficiary, dateOfBirth: dateFormat(beneficiary.dateOfBirth)}));

    const mapParameterIdToCode = (parameterType, parameterId) => {
      const parameter = this.parameters[parameterType].find(p => p.idParameter === parameterId);
      return parameter ? parameter.code : '';
    }

    const formatToFetch = formattedDate.map(data => ({
      idRelationship: data.relationship,
      codeRelationship: mapParameterIdToCode('relationshipTypes', data.relationship),
      idHealthStatus: data.healthCondition,
      codeHealthStatus: mapParameterIdToCode('healthStatusTypes', data.healthCondition),
      gender: mapParameterIdToCode('sexStatusTypes', data.gender),
      birthdate: data.dateOfBirth,
    }));

    return formatToFetch;
  }
}

export default BusinessParameters;